/**
 * @fileoverview Searcher Page SearchController Module.
 * Manages the behavior and interactions of the search filters on the search page.
 * This includes handling tab-based filtering and UI state changes for the search results.
 */

import { addParamToUrl, closeAllDropdowns, elementExists, getContentTypeFromUrl } from "../../Utils";
import {handleChangeTab} from "./navigation/tabManager";
import {hideOrShowPagination} from "./navigation/paginationUtils";

const SearchController = {
    searchPageSelector: '#search-page-js',
    /**
     * Initializes the SearchController.
     * Sets up the event listeners if the search page element exists.
     */
    init() {
        if( ! elementExists(this.searchPageSelector)) return;
        const contentType = getContentTypeFromUrl();
        this.setListeners();
        hideOrShowPagination(contentType);
    },

    /**
     * Sets up event listeners for search filters.
     */
    setListeners() {
        const searchFilters = document.querySelectorAll('.searcher-tab-filter-js, .tablink');
        searchFilters.forEach(filter => {
            filter.addEventListener('click', (ev) => this.filterClickedHandler(ev))
        });
        this.setKeyUpEnterListener();
    },

    setKeyUpEnterListener() {
        const inputElement = document.querySelector('#searchbox input');
        const buttonElement = document.querySelector('#searchbox-button');
        buttonElement.addEventListener('click', function() {
            const query = inputElement.value;
            const event = new CustomEvent('searchExecuted', { detail: { query: query } });
            document.dispatchEvent(event);
        });
        inputElement.addEventListener('keypress', function(event) {
            const query = event.target.value;
                if (event.key === 'Enter') {
                    const event = new CustomEvent('searchExecuted', { detail: { query: query } });
                    document.dispatchEvent(event);
                }
        });
    },

    /**
     * Handles click events on search filters.
     * Toggles visibility of tab content based on the selected filter.
     * @param {Event} ev - The event object.
     */
    filterClickedHandler(ev) {
        const slug = ev.target.dataset.slug;
        const event = new CustomEvent('filterClicked', { detail: { slug: slug } });
        document.dispatchEvent(event);
        handleChangeTab(slug);
        closeAllDropdowns();
        hideOrShowPagination(slug);
        addParamToUrl('content_type', slug);
    },
};

export default SearchController;
